/**
 * System API Client
 * Deploy-environment metadata — see apps/api/src/routes/system.ts.
 */

import { apiFetch } from './api.core';

export interface SystemEnvironment {
  isProduction: boolean;
}

export async function fetchSystemEnvironment(): Promise<SystemEnvironment> {
  return apiFetch<SystemEnvironment>('/api/system/environment');
}
